import styled from 'styled-components';

const TableHead = styled.th`
  text-align: center;
  font-size: 12px !important;
  width: ${({ width }) => width || 'auto'};
`;

export default TableHead;
